export const isPresent = <T>(item: T | null | undefined): item is T => {
  return item !== null && item !== undefined
}

export function assertPresence<T>(
  item: T | null | undefined,
): asserts item is T {
  if (!isPresent(item)) {
    throw new TypeError(`Item presence expected, got "${item}"`)
  }
}

export function assertNever(value: never): never {
  throw new Error(
    `Unexpectedly reached a unreachable code path with value: ${value}`,
  )
}
